import { render, staticRenderFns } from "./UIModal.vue?vue&type=template&id=8fb4f6b8&scoped=true"
import script from "./UIModal.vue?vue&type=script&lang=js"
export * from "./UIModal.vue?vue&type=script&lang=js"
import style0 from "./UIModal.vue?vue&type=style&index=0&id=8fb4f6b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb4f6b8",
  null
  
)

export default component.exports